<template>
  <div>
    <table-base ref="table" GetAction="GetSeachList" SaveAction="SaveAdmin" DelAction="DelUser" Controller="Admin" :TopButtons="TopButtons" :FormParams.sync="FormParams" TableButtonWidth="180px"
    :TopSeach="TopSeach" :TableColumns="TableColumns" :TableButtons="TableButtons" @tableButtonClick="tableButtonClick"></table-base>
  </div>
</template>

<script>
export default {
  name: "Admin",
  title: "管理员设置",
  data () {
    return {
      TopButtons: [
        { name: "添加", action: "add", type: "primary", back: this.addBack }
      ],
      TopSeach: [
        { name: "", param: "input", default: "", type: "text", placeholder: "请输入关键字" }
      ],
      TableColumns: [
        { name: "序号", type: "index", param: "", width: "50px" },
        { name: "账号", param: "login_Name" },
        { name: "姓名", param: "name" },
        { name: "状态", param: "state" }
      ],
      TableButtons: [
        { name: "编辑", action: "update", back: this.upBack },
        { name: "启用禁用", action: "enable", format: (row) => { return row.state == "正常" ? '禁用' : '启用' }, color: "#f56c6c" }
      ],
      FormParams: [
        { name: "账号", param: "login_Name", default: "", disabled: true, placeholder: "" },
        { name: "姓名", param: "name", default: "", disabled: true, placeholder: "" },
        { name: "角色", param: "roleId", type: "select", action: "SystemRole" },
      ]
    }
  },
  components: {
    TableBase: resolve => require(["@/components/System/components/TableBase"], resolve)
  },
  mounted () {

  },
  methods: {
    checkUserBack (user = 1) {
      this.$refs.table.ShowMail = false
      console.log(user);
    },
    addBack () {
      this.$refs.table.visible = false
      this.FormParams = [
        { name: "选择人员", param: "login_Name", type: "mailList", checkType: 2, default: "", placeholder: "选择人员", back: this.setUser },
        { name: "角色", param: "roleId", type: "select", action: "SystemRole" },
      ]
      setTimeout(() => {
        this.$refs.table.reloadModel();
        this.$refs.table.visible = true
      }, 200);
    },
    upBack () {
      this.FormParams = [
        { name: "账号", param: "login_Name", default: "", disabled: true, placeholder: "" },
        { name: "姓名", param: "name", default: "", disabled: true, placeholder: "" },
        { name: "角色", param: "roleId", type: "select", action: "SystemRole" },
      ]
    },
    tableButtonClick (row, type) {
      if (type == "enable") {
        this.Ajax.Post("/api/Admin/Enable/" + row.objectID).then(res => {
          this.$tool.System.msg("操作成功！", "提示", 0);
          this.$refs.table.GetList();
        })
      }
    },
    setUser (model, dt) {
      this.$refs.table.visible = false
      this.FormParams = [
        { name: "账号", param: "login_Name", default: dt.id, disabled: true, placeholder: "" },
        { name: "姓名", param: "name", default: dt.name, disabled: true, placeholder: "" },
        { name: "角色", param: "roleId", type: "select", default: model.roleId, action: "SystemRole" },
      ]
      setTimeout(() => {
        this.$refs.table.reloadModel();
        this.$refs.table.visible = true
      }, 100);

    }
  },
}
</script>